'use client'

import { useWatch } from 'react-hook-form'

import { AdvancedTwapBandToggle } from '@/features/advanced-twap/components/advanced-twap-band-toggle'
import { AdvancedTwapDurationInput } from '@/features/advanced-twap/components/advanced-twap-duration-input'
import { AdvancedTwapReduceOnlyToggle } from '@/features/advanced-twap/components/advanced-twap-reduce-only-toggle'
import { useUnifiedOrderFormContext } from '@/features/order/order-form/lib/order-form-context'

function DurationFields() {
  const { form } = useUnifiedOrderFormContext()
  const [durationSeconds, totalSlices] = useWatch({
    control: form.control,
    name: ['advancedTwapDurationSeconds', 'advancedTwapTotalSlices'],
  })

  return (
    <AdvancedTwapDurationInput
      durationSeconds={durationSeconds || ''}
      onDurationChange={(value) => form.setValue('advancedTwapDurationSeconds', value)}
      totalSlices={totalSlices || ''}
      onTotalSlicesChange={(value) => form.setValue('advancedTwapTotalSlices', value)}
    />
  )
}

function BandFields() {
  const { form } = useUnifiedOrderFormContext()
  const [enabled, pct] = useWatch({
    control: form.control,
    name: ['advancedTwapBandEnabled', 'advancedTwapBandPct'],
  })

  return (
    <AdvancedTwapBandToggle
      enabled={enabled || false}
      onEnabledChange={(next) => form.setValue('advancedTwapBandEnabled', next)}
      pct={pct || ''}
      onPctChange={(value) => form.setValue('advancedTwapBandPct', value)}
    />
  )
}

function ReduceOnlyField() {
  const { form } = useUnifiedOrderFormContext()
  const checked = useWatch({ control: form.control, name: 'advancedTwapReduceOnly' })

  return (
    <AdvancedTwapReduceOnlyToggle
      checked={checked || false}
      onCheckedChange={(next) => form.setValue('advancedTwapReduceOnly', next)}
    />
  )
}

/**
 * Composes the Advanced TWAP tab's own params, mirroring how RfqParams composes the RFQ
 * tab's — mounted directly below the shared order rows when isAdvancedTwapMode.
 *
 * No catchup section here — the catchup leg (frequency + order size) is derived
 * automatically from duration/total slices/quantity at submit time
 * (build-advanced-twap-params.ts), not user-configurable.
 */
export function AdvancedTwapParams() {
  return (
    <div className="flex flex-col gap-4">
      <div data-tutorial="slices">
        <DurationFields />
      </div>
      <BandFields />
      <ReduceOnlyField />
    </div>
  )
}
